const pluginCommissionProject = {
  id: "pluginCommission",
  title: "Plugin Commissions",
  titleIntro: "Overview",
  role: "Plugin Developer",
  startDate: "August 2024",
  endDate: "Present",
  banner: "/images/pluginCommission/banner.jpeg",
  detailBanner: "/images/pluginCommission/banner.jpeg",
  overview: [
    "Recently, I've been developing custom Spigot plugins for clients tailored to their needs. These commissions are usually low scale projects that can be completed quickly.",
    "Below are some examples of plugins I've developed for various content creators. If the video these plugins were created for has released, you'll be able to find a link to the video in the plugin's description.",
    "Some of these plugins are available for purchase on my Patreon at https://www.patreon.com/c/invic",
    "If you're a content creator and are interested in commissioning a low scale plugin, feel free to reach out to me via Discord.",
  ],
  nextPreview: "Examples of my plugin commission work:",
  features: [
    {
      id: "whosThePro",
      title: "Who's The Pro? (Minecraft Odd One Out)",
      pretext: "A social deduction plugin where players must identify the hidden speedrunner.",
      featuredImage: "/images/pluginCommission/whosthepro.jpg",
      videoUrl: "https://www.youtube.com/watch?v=mTkSfSIdfyM",
      description: [
        "This plugin was created to run an Among Us-style recording session where one player is secretly trying to beat the game and the others are trying to stop them.",
        "All players have their skins and names hidden and replaced with generic identifiers (Player1, Player2, etc.), making it impossible to tell who is who. Players are also forced to use proximity voice chat with a voice changer active.",
        "The other players must work together to identify the speedrunner through observation of behavior and gameplay patterns including Advancement Announcements.",
        "Key features include:",
        "- Complete identity concealment system that masks player skins and names",
        "- Private messaging system allowing players to communicate only with the host to cast votes",
        "- Admin commands for revealing player identities, assigning players to be excluded from randomization, and more",
      ]
    },
    {
      id: "oreChests",
      title: "Minecraft, but Ores are Chests",
      pretext: "A plugin that allows players to open ores like chests to get randomized loot.",
      featuredImage: "/images/pluginCommission/orechests.jpeg",
      videoUrl: "https://youtu.be/KN5KrqU50W4",
      description: [
        "This plugin adds the ability for players to right click any ore to open them like chests, revealing randomized loot based on the ore type.",
        "The plugin also handles logic for dropping items from the ore's loot table when the block is broken or exploded.",
        "Key features include:",
        "- Special 'rainbow ore' (10% chance to replace diamond ore) that contains the most valuable loot",
        "- Resource Pack based Custom textures that make ores looks like chests of that ore type",
        "- Balanced loot tables with a visually appealing item distribution within the chest",
        "After gearing up for roughly 30 minutes, players will have obtained enough items to have a fun PVP experience with their friends."
      ]
    },
    {
      id: "randomMobs",
      title: "Minecraft, but Random Mobs Spawn Every 10 Seconds",
      pretext: "A plugin that spawns mobs on players every 10 seconds.",
      featuredImage: "/images/pluginCommission/randommobs.png",
      description: [
        "This plugin challenges players to defeat the Ender Dragon while avoiding constant random mobs spawning at their location.",
        "Key features include:",
        "- Configurable spawn timer (default: every 10 seconds)",
        "- Customizable mob scale",
        "- Option to include non-living entities (minecarts, wind charges, wither skulls, etc.)",
        "- Per player activation so manhunt style games can be played out"
      ]
    },
    {
      id: "angryMobs",
      title: "Minecraft, but Every Mob is Angry",
      pretext: "A plugin that turns every mob in the game into a hostile enemy.",
      featuredImage: "/images/pluginCommission/angrymobs.png",
      description: [
        "This plugin challenges players to defeat the Ender Dragon while being hunted by every type of mob, regardless of their normal behavior.",
        "Key features include:",
        "- All passive and neutral mobs are always angry at players",
        "- Piglins ignore gold armor and will attack players regardless",
        "- Custom damage values for mobs that don't normally have attack damage",
        "- Configuration file to add or remove specific mobs from the aggressive behavior list or adjust attack damage values",
      ]
    },
    {
      id: "weaponPedestals",
      title: "Weapon Pedestals Plugin",
      pretext: "A plugin that implements my design for Legendary Weapon pedestals in Spigot.",
      featuredImage: "/images/pluginCommission/pedestals.png",
      description: [
        "This plugin implements my design for Legendary Weapon pedestals as a standalone Spigot plugin utilizing only vanilla assets.",
        "Opped players can interact with pedestals to access a simple chest GUI where the first slot contains the result item and the remaining slots are used for recipe ingredients.",
        "Players who have all the recipe ingredients can right click the pedestal to craft the item, sending an announcement to all players.",
        "Key features include:",
        "- Support for custom item types, ex. Hearts",
        "- Option to exclude specific items from being considered as recipe ingredients via persistant data containers",
        "- Flexible usage modes: single-use (one craft per pedestal) or per-player use (each player can craft once)",
        "- Admin commands to adjust height and scale of floating text and item models, remove player completion status to allow re-crafting, and change the pedestal's usage mode between single-use and per-player",
        "- Proximity-based command system that automatically targets the nearest pedestal, making command usage simple",
      ]
    },
  ]
};

export default pluginCommissionProject; 